import type { LocaleMessageBundle } from '../../types'
import { saleReturnMessages as saleReturnFeatureMessages } from './sale-return'

export const saleReturnMessages: LocaleMessageBundle = {
  vi: {
    ...saleReturnFeatureMessages.vi,
  },
  en: {
    ...saleReturnFeatureMessages.en,
  },
}
